var startOfSecond = require('./start_of_second')

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 */
var isSameSecond = function(dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return(
    dateLeftStartOfSecond.getTime() == dateRightStartOfSecond.getTime()
  )
}

module.exports = isSameSecond




/** WEBPACK FOOTER **
 ** ./src/is_same_second.js
 **/